import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup, ɵValue } from '@angular/forms';
import { UUID } from 'symbols';
import { DebtFormGroup } from '../symbols';

@Pipe({
  name: 'checkDebts',
  standalone: true
})
export class CheckPipe implements PipeTransform {
  transform(debts: Array<ɵValue<FormGroup<DebtFormGroup>>>, docId: UUID): boolean {
    return !!debts.find(debt => !debt.paidOff && (debt.orderId !== docId && debt.contractId !== docId && debt.talonId !== docId && debt.standId !== docId));
  }
}
